import { useTranslation } from 'react-i18next'
import { twMerge } from 'tailwind-merge'
import type {
  GenerationModelType,
  TrainingTask,
} from 'src/services/apollo/generated/graphql'
import { getTrainingTaskLabelAndStyle } from './trainingTask'

export function TrainingTaskStatusChip(
  props: {
    trainingTask: TrainingTask
    modelType?: GenerationModelType
  } & StyleProps,
) {
  const { t } = useTranslation(['market'])
  const chipProps = getTrainingTaskLabelAndStyle(t, props.trainingTask)
  if (!chipProps) return null
  return (
    <span
      className={twMerge(
        'rounded-xl select-none font-medium text-black',
        chipProps.className,
        props.className,
      )}
    >
      {chipProps.label}
    </span>
  )
}
